import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import EventDetailsCard from '../../components/EventDetailsCard/EventDetailsCard';
import FAQ from '../../components/FAQ/FAQ';
import PackagePriceCard from '../../components/PackagePriceCard/PackagePriceCard';
import { Programs as ProgramsEN } from '../../data/programs';
import { Programs as ProgramsRU } from '../../data/ruprograms';
import BackTo from '../../components/ui/BackTo/BackTo';
import './EventDetails.css';
import BenefitsContainer from '../../components/BenefitsContainer/BenefitsContainer';
import MasterSection from '../../components/MasterSection/MasterSection'; 
import { eventFAQ, eventFAQru, bookClubFAQ, bookClubFAQRu, foodFAQ, foodFAQRu } from './../../data/faqMain';
import VideoCointainerEvents from '../../components/VideoCointainerEvents/VideoCointainerEvents';

const EventDetails: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { programId, eventId } = useParams();
  const navigate = useNavigate();

  // ✅ Ensure eventId is always lowercase and trimmed to prevent mismatches
  const cleanEventId = eventId ? eventId.trim().toLowerCase() : "";

  console.log("Event ID received:", eventId);
  console.log("Clean Event ID:", cleanEventId);
  console.log("Current Language:", i18n.language);

  // ✅ Select the correct programs data based on the current language
  const Programs = i18n.language === 'ru' ? ProgramsRU : ProgramsEN;

  const program = Programs.find((p) => p.id === programId);
  if (!program) {
    return <h1>{t("program_not_found")}</h1>;
  }

  const event = program.events.find((e) => e.id.toLowerCase() === cleanEventId);
  if (!event) {
    return <h1>{t("event_not_found")}</h1>;
  }

  // ✅ Set default FAQ dataset
  let faqData = i18n.language === 'ru' ? eventFAQru : eventFAQ;

  // ✅ Override FAQ for specific events (ensure lowercase matching)
  if (cleanEventId === "event2") {
    faqData = i18n.language === 'ru' ? bookClubFAQRu : bookClubFAQ;
  } else if (cleanEventId === "p4e4b1") {
    faqData = i18n.language === 'ru' ? foodFAQRu : foodFAQ;
  }

  console.log("FAQ Data selected:", faqData);

  const handleBuyNow = () => {
    if (event.stripeLink) {
      window.location.href = event.stripeLink;
    } else {
      alert(t("no_stripe_link"));
    }
  };

  const goToMasterPage = () => {
    if (program.masterId) {
      navigate(`/masters/${program.masterId}`);
    }
  };

  return (
    <div style={{ marginTop: '80px' }}>
      <BackTo text={t("programs")} />

      <EventDetailsCard
        date={event.date}
        speakersName={program.Masters}
        location={event.location}
        priceOfEventRu={event.priceOfEventRu}
        locationLink={event.locationLink}
        time={event.time || t("tbd")}
        title={event.name}
        description={event.description || t("no_description")}
        image={event.image}
        buttonText={t("buy_tickets")}
        onButtonClick={handleBuyNow}
        stripeLinkOnline={event.stripeLinkOnline}
        priceOfEventRuOnline={event.priceOfEventRuOnline}
        speakersLink={`/masters/${program.masterId}`}
        eventPrice={event.priceOfEvent || "TBD"}
        priceOfEventOnline={event.priceOfEventOnline || "TBD"}
        stripeLink={event.stripeLink || ""}
        listOfBenefits={event.listOfBenefits}
        eventType={event.eventType}
        isSoldOut={event.isSoldOut} kassaLink={event.kassaLink}      />

      <BenefitsContainer
        benefitTitle={event.keyTakeaways.map(takeaway => takeaway.title)}
        description=""
        benefits={event.keyTakeaways.map(takeaway => takeaway.description)}
      />

      {event.videoLink && (
        <VideoCointainerEvents videoThumbnail={event.image} videoUrl={event.videoLink} />
      )}

      <MasterSection
        backgroundImage={program.programMasterImage}
        title={program.Masters}
        subtitle={t("expert_in_field")}
        actionText={t("learn_more")}
        onActionClick={goToMasterPage}
      />

      <PackagePriceCard
        title={event.name}
        description={event.priceDescription}
        price={event.priceOfEvent || "TBD"}
        buttonText={t("buy_now")}
        subtext={' '}
        onButtonClick={handleBuyNow}
        isSoldOut={event.isSoldOut}
      />

      {/* ✅ Dynamically switch FAQ data */}
      <FAQ data={faqData} />
    </div>
  );
};

export default EventDetails;
